import _ from 'lodash';
import moment from 'moment';
import { addStakeholderBody, updateStakeholderBody } from '../../lib/stakeholder.utils';
import { contactmoments } from '../bff.api';
import responseValidators from '../response.validators';

const _createBody = (data) => {
  const result = _.pick(data, ['date', 'subject', 'description', 'startTime', 'endTime', 'involved']);

  if (result.date) {
    result.date = moment(result.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
  }

  return result;
};
const _updateBody = _createBody;

const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const add = async (dossierId, data, options = {}) => {
  return contactmoments
    .add(dossierId, _createBody(data))
    .then((resp) => {
      responseValidators.addContactmoment(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const update = async (dossierId, contactMomentId, data, options = {}) => {
  return contactmoments
    .update(dossierId, contactMomentId, _updateBody(data))
    .then((resp) => {
      responseValidators.updateContactmoment(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const remove = async (dossierId, contactmomentId, options = {}) => {
  return contactmoments
    .delete(dossierId, contactmomentId)
    .then((resp) => {
      responseValidators.deleteContactmoment(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const addStakeholder = async (dossierId, contactmomentId, data, options = {}) => {
  return contactmoments
    .addStakeholder(dossierId, contactmomentId, addStakeholderBody(data))
    .then((resp) => {
      responseValidators.addContactmomentStakeholder(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const updateStakeholder = async (dossierId, contactMomentId, stakeholderId, data, options = {}) => {
  return contactmoments
    .updateStakeholder(dossierId, contactMomentId, stakeholderId, updateStakeholderBody(data))
    .then((resp) => {
      responseValidators.updateContactmomentStakeholder(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const removeStakeholder = async (dossierId, contactmomentId, stakeholderId, options = {}) => {
  return contactmoments
    .deleteStakeholder(dossierId, contactmomentId, stakeholderId)
    .then((resp) => {
      responseValidators.deleteContactmomentStakeholder(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const contactMomentsService = {
  add,
  update,
  remove,
  addStakeholder,
  updateStakeholder,
  removeStakeholder
};

export default contactMomentsService;
